export enum CurrencyCode {
  AUD = 'AUD',
  EUR = 'EUR',
  GBP = 'GBP',
  NZD = 'NZD',
  USD = 'USD'
}
